import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Panel from 'wonderbly-components/lib/Panel';
import OrderImages from './OrderImages';
import OrderStatus from './OrderStatus';
import OrderDelivery from './OrderDelivery';
import OrderInformation from './OrderInformation';
import OrderButtons from './OrderButtons';
import './Order.scss';

const Order = ({
  number,
  state,
  isCancelled,
  items,
  shipping: { delivery, trackingLink },
}) => {
  return (
    <Panel className={cx('order', { [`order--${state}`]: state })}>
      <OrderImages items={items} isCancelled={isCancelled}/>
      <Panel.Section>
        <div className="order__content">
          <OrderStatus status={state}/>
          <OrderDelivery delivery={delivery}/>
          <OrderInformation
            items={items}
            number={number}
            isCancelled={isCancelled}
          />
        </div>
        <div className="order__buttons">
          <OrderButtons>
            <OrderButtons.View
              number={number}
              state={state}
            />
            <OrderButtons.Track
              state={state}
              url={trackingLink}
            />
            <OrderButtons.Help
              state={state}
            />
          </OrderButtons>
        </div>
      </Panel.Section>
    </Panel>
  );
};

Order.propTypes = {
  number: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  processAt: PropTypes.string.isRequired,
  isCancelled: PropTypes.bool.isRequired,
  isInactive: PropTypes.bool.isRequired,
  items: PropTypes.array.isRequired,
  shipping: PropTypes.shape({
    trackingLink: PropTypes.string,
    delivery: PropTypes.object.isRequired
  }),
  handleOnClick: PropTypes.func.isRequired,
};

export default Order;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Order/Order.js